<template>
  <vue-daum-map
    :appKey="appKey"
    :center="{lat:37.52388267266389, lng:126.92413793738014}"
    :level.sync="level"
    :mapTypeId="mapTypeId"
    :libraries="libraries"
    @load="onLoad"
    @update:center="center=$event" 
    style="height:500px; width:1200px;"
    class="mx-auto"
  />
</template>

<script>
  import VueDaumMap from 'vue-daum-map';
  export default {
    name: 'DaumMap',
    components: { VueDaumMap },
    data: () => ({
      count: 0,
      appKey: 'c78f2395692dd0ecca999d9543196d3e',
      center: {lat:37.52388267266389, lng:126.92413793738014}, // 지도의 중심 좌표
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
      libraries: ['services'], // 추가로 불러올 라이브러리
      map: null // 지도 객체. 지도가 로드되면 할당됨.
    }),
     methods: {
      onLoad (map) {
        this.map = map;

        var daummaps = window.daum.maps;
        if (daummaps) {
          //var latlng = new daummaps.LatLng(37.524006, 126.924499)
          var latlng = new daummaps.LatLng(37.52388267266389, 126.92413793738014)
          var marker = new daummaps.Marker({
            position: latlng
          })
          marker.setMap(map)
            this.map = map
        }
      }
    }
  }
</script>
